module.exports = __webpack_public_path__ + "static/img/NALS_android_splash.6626189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/NALS_android_splash.png
// module id = ZoeB
// module chunks = 0